import { mapValues } from 'lodash'
import Vue from 'vue'

import forEachSync from 'linna/util/forEachSync'

import soundConfig from '@/assets/sounds'

import config from '@/config'

import store from '@/store'

// Data to use for generating players
// NOTE: we normalize the config here
const sounds = mapValues(soundConfig, (sound) => {
  return {
    data: null,
    volume: 1,
    ...sound
  }
})

export default new Vue({
  store,

  data () {
    return {
      sounds,

      // Playable audio elements per type
      players: []
    }
  },

  created () {
    this.resetAllPlayers()
  },

  methods: {

    normalizeVolume (volume) {
      return config.internalSoundVolume * this.$store.getters.globalVolumeMultiplier * Math.min(Math.max(volume, 0.1), 1)
    },

    resetAllPlayers () {
      this.players = mapValues(sounds, () => {
        return []
      })

      for (const type in this.sounds) {
        this.preloadPlayer(type)
      }
    },

    preloadPlayer (type) {
      this.players[type].push(this.getNewPlayer(type))
    },

    getNewPlayer (type) {
      if (!this.sounds[type]) {
        throw new Error('Attempting to use unavailable sound "' + type + '"')
      }

      const player = new Audio(this.sounds[type].data)
      player.volume = this.normalizeVolume(this.sounds[type].volume)

      return player
    },

    getLatestPlayer (type) {
      return this.players[type][this.players[type].length - 1]
    },

    unloadOldestPlayer (type) {
      this.players[type].shift()
    },

    async play (...types) {
      return forEachSync(types, this.playOne)
    },

    async playOne (type) {
      return new Promise((resolve) => {
        // We should have a player already loaded, so we use that
        const player = this.getLatestPlayer(type)

        // We're committed to using a player - let's preload a new one for the next time
        this.preloadPlayer(type)

        // const callback = () => {
        //   this.unloadOldestPlayer(type)
        //   // player.removeEventListener('ended', callback)
        //   resolve()
        // }

        // When this guy completes, we'll resolve and unload
        player.onended = () => {
          this.unloadOldestPlayer(type)
          resolve()
        }

        // Let's play this guy
        player.play()
      })
    }

  }

})
